import { Model, Attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

@Model()
export default class VehicleType extends ApplicationRecord {
  static jsonapiType = 'vehicle-types';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
      {
        text: 'Name',
        value: 'name',
      },
    ];
  }

  static scopeFactory() {
    return VehicleType.includes([]);
  }

  @Attr() name: string;
}
